import React from 'react';


const BookingsContent = () => {
    return (
        <div className="max-w-[100rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mt-40">
            {/* mx-auto */}
            {/* Card */}
            <div className="flex flex-col">
                <div className="overflow-x-auto [&::-webkit-scrollbar]:h-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500">
                    <div className="min-w-full inline-block align-middle">
                        ToDO: calendar
                    </div>
                </div>
            </div>
            {/* End Card */}
        </div>
    );
};

export default BookingsContent;